
import { Paper, Typography, Button, Box, useTheme } from '@mui/material';

export default function AboutPi() {
  const theme = useTheme();
  
  return (
    <Paper sx={{ p: 2, flex: 1, minWidth: 300 }}>
      <Typography variant="h6" gutterBottom>
        About π (Pi)
      </Typography>
      <Typography variant="body2" paragraph>
        Pi (π) is the ratio of a circle's circumference to its diameter, approximately equal to 3.14159. It's an irrational number, meaning it continues infinitely without repeating.
      </Typography>
      <Typography variant="body2" paragraph>
        Memorizing digits of Pi has become a popular mental challenge, with the world record exceeding 70,000 digits memorized.
      </Typography>
      <Typography variant="body2" paragraph>
        Pi Day is celebrated on March 14th (3/14) each year by math enthusiasts around the world.
      </Typography>
      
      <Box sx={{ mt: 3 }}>
        <Typography variant="h6" gutterBottom>
          Pi Challenge Memory Tips
        </Typography>
        <ul>
          <li>Break down digits into memorable chunks</li>
          <li>Use personalized memory techniques</li>
          <li>Practice regularly</li>
          <li>Visualize digit patterns</li>
          <li>Use the memory palace technique</li>
        </ul>
      </Box>
    </Paper>
  );
}
